<template>
<div class="term">
  <app-header/>
  <div class="main plaintext-page">
    <div class="ui-box">
      <h3 style="text-align:center">
        隐私政策
      </h3>
      <h4 style="text-align:right">
        隐私政策更新及生效日期：2021年7月12日
      </h4>
      <div class="ui-box-con">
        <div class="txt-con">
          欢迎您使用我们的产品和服务，我们深知个人信息对您的重要性，因此，我们制定了本《隐私政策》，向您说明了我们如何收集、使用、披露、转让和存储您的信息。请您仔细阅读我们的隐私政策，如有任何问题，请按照本政策中提供的联系方式与我们联系。
        </div>

        <div class="txt-con" >
          <h4>隐私申明</h4>
          我们严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：<br />
          1.安全可靠：<br />
          <p>我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。</p>
          2.自主选择：<br />
          <p>我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息 。</p>
          3.合理必要：<br />
          <p>为了向您和其他用户提供更好的服务，我们仅收集必要的信息。</p>
          4.清晰透明：<br />
          <p>我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息收集及处理方式。</p>
        </div>
        <div class="txt-con">
          <h4>一、我们收集的信息</h4>
          <h4 style="text-indent:1em;">（一）您在使用我们服务时主动提供的信息</h4>
          <h4 style="text-indent:2em;">1. 您在注册账户时填写的信息</h4>
          <p>我们将收集您在注册时填写的手机号码、其他第三方授权注册登录的<a style="font-weight: bold;">账号、安全邮箱、昵称</a>等信息。</p>
          <h4 style="text-indent:2em;">2. 您通过我们的客服或参加我们举办的活动时所提交的信息</h4>
          <p>您参与我们线上活动时填写的调查问卷中可能包含您的<a style="font-weight: bold;">姓名、电话、家庭地址</a>等信息。</p>
          <h4 style="text-indent:1em;">（二）您在使用我们服务时我们收集的信息</h4>
          <h4 style="text-indent:2em;">1.您的交易行为产生的信息</h4>
          <p>当您在我们平台上进行交易时，我们为了保障您的交易安全，将采集您的<a style="font-weight: bold;">服务日志，IP地址，登录信息，账户信息，计算机和连接信息诸如浏览器的类型、版本和时区设置、浏览器插件类型和版本、操作系统和平台。</a></p>
          <h4 style="text-indent:2em;">2.保障账号安全所必须收集的信息</h4>
          <p>为了保障您的账号安全，我们将会收集网站网络日志，并跟踪全天的页面访问数据，全天页面访问数据被用来反映网站的流量，我们可以据此为未来的发展制定计划（例如增加服务器），及时发现网站流量的异常情况。</p>
        </div>
        <div class="txt-con">
          <h4>二、我们如何使用您的个人信息</h4>
          <p>我们严格遵守法律法规的规定及与您的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</p>
          <p>1.满足您的个性化需求：例如相关设置或帮助服务，或者与其他信息合并在一起，用于提供和改进我们的产品、服务、内容和广告宣传。</p>
          <p>2.安全保障</p>
          <p>我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。</p>
          <p>3.邀请您参与有关我们服务的调查</p>
          <p>为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。</p>
          <p>4.向您发送我们的通知或重要事项</p>
          <p>我们会不时地使用你的个人信息以发送重要通知，如关于购买以及我们的条款、条件和政策变更的通讯。</p>
          <p>5.其他国家法律法规或监管要求的目的</p>
          <p>我们还会将个人信息用于审计或其他国家法律法规规定的必要目的。</p>
        </div>
        <div class="txt-con">
          <h4>三、我们如何使用Cookie、标识符及相关技术</h4>
          <p>我们的网站、在线服务电子邮件消息和广告宣传可能会使用 “cookies” 和其他技术，如像素标签和网站信标。</p>
          <p>此等技术帮助我们更好地了解用户的行为，我们将通过 cookies 和其他技术收集的信息视为非个人信息，您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
        </div>
        <div class="txt-con">
          <h4>四、信息存储及保护</h4>
          <h4 >（一）存储</h4> 
          1.存储地点
          <p>我们会按照相关法律法规的规定，将中国境内收集的用户个人信息存储于中国境内。</p>
          2.存储期限
          <p>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律法规或国家相关部门有强制的留存要求。</p>
          <h4 >（二）个人信息的保护</h4>
          <p>为了保障您的信息安全，我们在收集您的信息后，将采取各种合理必要的措施保护您的信息。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。同时，我们建立了相关的内部管理流程，对可能接触到您的个人信息的工作人员采取最小够用授权原则。</p>
          <p>我们设立了统一的个人信息保护责任机制，有关个人信息保护的诉求与事项，您可以通过本政策最后提供的联系方式与我们联系。客服人员验证您的身份后，会将相关事项转交给个人信息保护责任人处理，我们将在15日内答复您关于个人信息相关的请求。</p>
          <p style="font-weight: bold;text-indent:2em;">请您务必妥善保管好您的账号及其他相关身份要素，在使用服务时设置复杂密码并定期进行更换，以协助我们保护您的账户安全。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的后果。当您发现您的账号及其他相关身份要素已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施。</p>
        </div>
        <div class="txt-con">
          <h4>五、我们如何共享、转让、公开披露您的信息</h4>
          <h4>（一）共享</h4>
          <p>我们承诺对您的信息进行严格保密，我们不会与除我们以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
          <h4 style="text-indent:2em;">情形一：法律法规及监管部门另有规定的情况下共享。</h4>
          <h4 style="text-indent:2em;">情形二：提供您需要的产品或服务必要的情况下共享给第三方，包括关联公司、合作的机构以及其他合作伙伴。</h4>
          <h4 style="text-indent:2em;">情形三：在获取您的明确同意的情况下共享。</h4>
          <h4>（二）转让</h4>
          <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
          <p>1.事先获得您的明确同意；</p>
          <p>2.根据法律法规或强制性的行政或司法要求；</p>
          <p>3.在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。</p>
          <h4>（三）公开披露</h4>
          <p>未经您的授权或同意，除在公布中奖活动名单时会去标识展化示中奖者手机号、姓名、账户登录名、昵称外，原则上我们不会公开披露您的个人信息。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。</p>
          <h4>（四）委托处理</h4>
          <p>为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理信息。</p>
          <p>我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。在委托关系解除时，我们将及时督促其按照国家法律法规的要求，删除或匿名化处理您的个人信息。</p>
          <h4>（五）个人信息共享、转让及公开披露的特殊情形</h4>
          <p>根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</p>
          <p>1.与我们履行法律法规规定的义务相关的;</p>
          <p>2.与国家安全、国防安全直接相关的;</p>
          <p>3.与公共安全、公共卫生、重大公共利益直接相关的;</p>
          <p>4.与刑事侦查、起诉、审判和判决执行等直接相关的;</p>
          <p>5.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
          <p>6.您自行向社会公众公开的个人信息;</p>
          <p>7.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
          
        </div>
        <div class="txt-con">
          <h4>六、我们如何保护、处理未成年人的信息</h4>
          <p>本政策所指未成年人是根据《中华人民共和国未成年人保护法》规定的未满十八周岁的公民。</p>
          <p>证券公司的证券业务主要面向十八周岁以上公民使用，如果您是未满十八周岁的未成年人，建议请您的监护人阅读本政策或在监护人的指导下阅读本政策，并在取得您的监护人同意的前提下，向我们提供您的相关信息以便使用大智慧上除证券交易功能之外的服务。对于经监护人同意而收集您的信息的情况，我们只会在受到法律允许、监护人明确同意或者保护您的权益所必要的情况下使用或公开披露此信息。</p>
          <p>如您为未成年人的监护人，当您对该未成年人的信息处理存在疑问时，请通过本政策中披露的联系方式及时联系我们。</p>
        </div>
        <div class="txt-con">
          <h4>七、政策更新及联系方式</h4>
          <p>为更好的提供服务，根据用户需求、业务规则以及法律法规的要求，我们会适时对本政策的相关条款进行修订。对于条款重大变更或修订，我们会向您告知相关变化。如您对本政策存在任何疑问，或对于您的个人信息处理存在任何意见，请通过021-20219988与我们联系。</p>
          <p><a style="font-weight: bold;">为保障您的信息安全，我们可能需要先验证您的身份和凭证资料，</a>之后我们会及时处理、答复您的问题。一般来说，我们将在验证通过后的五个工作日内处理完成相关事项，特殊情形下最长将在不超过十五天或法律法规规定期限内向您作出答复。</p>
        </div>
        <div class="txt-con">
          <h4>八、其他</h4>
          <p>请您知晓，本隐私政策仅适用于本我们的官方网站，我们为您提供的各类产品，包括但不限于大智慧APP、大智慧365等软件，具体隐私政策应以各产品内部隐私政策为准。</p>
        </div>
      </div>
    </div>
  </div>
  <app-footer/>
</div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
export default {
  name: 'privacy',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/Privacy.vue